// extracted by mini-css-extract-plugin
export default {"info-box":"InfoBox_info-box__wJvhr","card":"InfoBox_card__f3FVW"};